module.exports = "https://static.energy5.com/_next/static/images/DocumentDeclined-bc69bcc85829accc2124cdf8c9645a0c.png";